
import React, {
  // PropTypes
} from 'react';

import {
  Navbar
} from 'react-bootstrap';

import FA from 'react-fontawesome';
import { Link } from 'react-scroll';

import app from '../../app_data/index';

const Brand = () => (
  <Navbar.Brand>
    <Link
      href="#brand"
      id="brand"
      to="app"
      // ... prob. safer than neg infinity.
      //     See tall nav bar height/margin.
      //     It's about 94px =~= 6.71rem (base font size = 14px).
      offset={-94}
      // offset={-1000}

      activeClass="active"

      spy
      smooth
      duration={500}
    >
      <span className="fa-stack" id="stack">
        <FA name="circle" stack="2x" id="stack_out" />

        <FA
          name={app.mainIcon}

          // name="rotate-right"
          // spin

          stack="1x"
          id="stack_in"
        />
      </span>

      <span id="name1">
        {app.titleFirstWord}
      </span> <span id="name2">
        {app.titleSecondToLastWords}
      </span>
    </Link>
  </Navbar.Brand>
);

// Brand.propTypes = {
//   appData: PropTypes.shape().isRequired
// };

export default Brand;



// WEBPACK FOOTER //
// ./src/components/nav_bar/Brand.js